import { Box } from '@mui/material'

import { BudgetPreviewsStatus } from '@components/shared/BudgetPreviewsStatus'
import { emotionTheme } from '@styles/theme'
import { formattedIsoToPtBrDateTime } from '@utils/dates/formattedIsoToPtBrDateTime'
import { TrendingDown } from '@assets/svgs/TrendingDown'
import { TrendingUp } from '@assets/svgs/TrendingUp'

import type { ColumnDefProps } from '@components/shared/Table/types'
import type { PreviewDetailsItemProps } from '../context/types'

interface ParseDetailedSummaryProps {
  data: PreviewDetailsItemProps[]
}

export const parseBudgetPreviewsGrid = ({ data }: ParseDetailedSummaryProps) => {
  if (!data) return []

  const parsedData: ColumnDefProps[][] = data.map((item) => [
    {
      id: 'previewNumber',
      columnName: 'Prévias',
      align: 'center',
      minWidth: '7rem',
      maxWidth: '7rem',
      value: item.previewNumber ? `${item.previewNumber}ª semana` : '-'
    },
    {
      id: 'previewBillingAmount',
      columnName: 'Total Faturamento (R$)',
      align: 'center',
      currency: true,
      value: item.previewBillingAmount || 0
    },
    {
      id: 'deviationValue',
      columnName: 'Desvio (R$)',
      align: 'center',
      currency: true,
      value: item.deviationValue || 0
    },
    {
      id: 'deviationPercentage',
      columnName: 'Desvio (%)',
      align: 'center',
      minWidth: '7rem',
      maxWidth: '7rem',
      value: (
        <>
          {item.deviationPercentage === 0 ? (
            <>0,00%</>
          ) : (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
                color:
                  item.deviationPercentage <= 0 ? emotionTheme.colors.error.color : emotionTheme.colors.success.color
              }}
            >
              {item.deviationPercentage <= 0 ? <TrendingDown size="small" /> : <TrendingUp size="small" />}
              {item.deviationPercentage ? `${item.deviationPercentage.toFixed(2)}%`.replace('.', ',') : '-'}
            </Box>
          )}
        </>
      )
    },
    {
      id: 'updatedAt',
      columnName: 'Última Atualização',
      align: 'center',
      minWidth: '10rem',
      maxWidth: '14.5rem',
      value: item.updatedAt ? formattedIsoToPtBrDateTime(item.updatedAt) : '-'
    },
    {
      id: 'previewStatus',
      columnName: 'Status da Prévia',
      align: 'center',
      minWidth: '10rem',
      maxWidth: '14.5rem',
      withoutTooltip: true,
      value: <BudgetPreviewsStatus status={item.previewStatus} />
    }
  ])

  return parsedData
}
